import { Box, Container } from "@mui/material";
import Image from "next/image";
import Link from "next/link";

export default function LoginLayout({
	children,
}: { children: React.ReactNode }) {
	return (
		<>
			<Container component="header" maxWidth="xs" style={{ padding: 0 }}>
				<Box
					px={2}
					height={64}
					display="flex"
					alignItems="center"
					justifyContent="space-between"
				>
					<Link href="/">
						<Image
							src="/logo-green.png"
							width={130}
							height={27}
							alt="ケアミーのロゴ"
						/>
					</Link>
				</Box>
			</Container>
			{children}
		</>
	);
}
